// extracted by css-extract-rspack-plugin
var _1 = "n31KVrvqx1MMmolv";
var _2 = "qyt2MEtbwpovtw5k";
var _3 = "G8IdyLvLVY8tDa2w";
var _4 = "gmQcRBRSoaYaBswt";
var _5 = "CGUpAZ7aAKrcYsfm";
export { _1 as "aplaBase", _2 as "aplaContent", _3 as "aplaDark", _4 as "aplaLight", _5 as "aplaWhite" }
